module.exports = __webpack_public_path__ + "img/1481249567.5b4598b9.jpg";